const validationMessage = {
    required: "This field is required",
    email: "Invalid email address",
    phone: "Invalid phone number",
    passwordConfirmNotMatch: "Passwords must match",
    passwordRule: "Minimum eight characters, at least one letter, one number and one special character (@,$,!,%,*,#,?,&)"
}
export default validationMessage;
